import { render, staticRenderFns } from "./UsuarioDashboardVendas.vue?vue&type=template&id=821034a0&scoped=true"
import script from "./UsuarioDashboardVendas.vue?vue&type=script&lang=js"
export * from "./UsuarioDashboardVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821034a0",
  null
  
)

export default component.exports